import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/takeWhile';

import { Injectable } from '@angular/core';
import { AppInsightsService } from '@markpieszak/ng-application-insights';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../../../../core/config.service';

export class LogMessage {
    private message: string;
    private data?: string;

    constructor(message: string, data?: string) {
        this.message = message;
        this.data = data;
    }
}

@Injectable()
export class LogService {
    private configLoaded: boolean;

    constructor(
        private appInsightsService: AppInsightsService,
        private configService: ConfigService) {
        Observable.interval(1000)
            .takeWhile(() => !this.configLoaded)
            .subscribe(() => {
                if (this.configService && this.configService.getEnv('appInsightsInstrumentationKey')) {
                    this.configLoaded = true;
                    this.initAppInsights();
                }
            });
    }

    public initAppInsights(): void {
        this.appInsightsService.config = {
            instrumentationKey: this.configService.getEnv('appInsightsInstrumentationKey')
        };
        this.appInsightsService.init();
    }

    public error(message: string, data: any): void {
        this.appInsightsService.trackException(new Error(this.configService.getEnv('loggingPrefix') + message), undefined, this.getLogData(data), undefined, AI.SeverityLevel.Error);
    }

    public debug(message: string, data: any): void {
        if (this.configService.getEnv('debugMode') === false) { return; }
        this.appInsightsService.trackTrace(this.configService.getEnv('loggingPrefix') + message, this.getLogData(data));
    }

    private getLogData(data: any): any {
        if (typeof (data) === 'string') {
            return { data: data };
        }
        return { data: JSON.stringify(data) };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/logging/log.service.ts